import styled from 'styled-components';
import { TableContainer } from '../SummaryTablesStyles';

export const TableContainerStyled = styled(TableContainer)`
  min-height: 19.2rem;
  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    min-height: 15.1rem;
  }
`;
